import React from 'react';
import { STATE_SECTIONS, BRAND } from '../../data/mock';
import { MapPin, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

export const StateSections = () => {
  return (
    <section id="states" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-teal-600 font-semibold text-sm uppercase tracking-wider mb-4">
            Our Coverage Areas
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Local Pet Insurance Experts Near You
          </h2>
          <p className="text-lg text-slate-600">
            Licensed and ready to serve pet owners across Florida, North Carolina, and Virginia
          </p>
        </div>

        {/* State Cards */}
        <div className="grid lg:grid-cols-3 gap-8">
          {STATE_SECTIONS.map((state, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 shadow-sm border border-slate-100 hover:shadow-xl hover:border-teal-200 transition-all duration-300 group"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-teal-500 to-cyan-600 flex items-center justify-center shadow-lg shadow-teal-500/20">
                  <MapPin className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-slate-800">{state.state}</h3>
                  <span className="text-sm text-slate-500">Pet Insurance</span>
                </div>
              </div>

              <p className="text-slate-600 mb-6 leading-relaxed">
                {state.description}
              </p>

              <div className="flex flex-wrap gap-2 mb-6">
                {state.cities.map((city, idx) => (
                  <Badge
                    key={idx}
                    variant="outline"
                    className="bg-slate-50 border-slate-200 text-slate-600 font-medium hover:bg-teal-50 hover:border-teal-200 hover:text-teal-700 transition-colors cursor-default"
                  >
                    {city}
                  </Badge>
                ))}
              </div>

              <Button
                asChild
                variant="outline"
                className="w-full group-hover:bg-teal-50 group-hover:border-teal-300 group-hover:text-teal-700 transition-all"
              >
                <a href={BRAND.quoteUrl} target="_blank" rel="noopener noreferrer">
                  Get {state.abbr} Quote
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </a>
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
